<icc-chip iccChipSmall iccChipStatus [color]="colorRgbHex" [focusable]="false">
    <icc-icon name="state"></icc-icon>
    {{ (name | translate) || ('INTERFACE|Niezdefiniowany' | translate) }}
</icc-chip>
